module.exports = __webpack_public_path__ + "img/4.afb07d84.svg";